import React, { FC } from "react";
import { Field } from "react-final-form";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import Autocomplete from "../../../../../components/Autocomplete";
import { LANGUAGES } from "../../../constants";

interface ILanguageProps {
  label: string;
  fieldName: string;
  disabled?: boolean;
  errors?: { [key: string]: string };
}

const Language: FC<ILanguageProps> = ({
  label,
  fieldName,
  errors,
  disabled = false,
}) => (
  <div>
    <FieldsGroupLabel
      isRequired
      label={label}
      hasError={!!errors}
      className="fields-group-label-first"
    />
    <Field
      fullWidth
      disabled={disabled}
      options={LANGUAGES}
      groupBy={(option) => option.popularity}
      getOptionLabel={(option) => option.name}
      placeholder="Please select"
      name={fieldName}
      component={Autocomplete}
    />
  </div>
);

export default React.memo(Language);
